export enum HeaderShowType {
  Status = 1, // 状态展示
  Candidate, // 候选人组合数据展示
  Progress, // 面试进展
  ExamType, // 面试方式
  UseTimeSecond, // 预计时长
  Time, // 时间展示
  Param // 公开字段
}

export interface HeaderColumn {
  label: string; // 列名
  prop?: string; // 属性名
  showType?: HeaderShowType; // 内容类型
  minWidth?: string; // 最小宽度
  width?: string; // 宽度
  fixed?: "left" | "right"; // 固定位置
  canWrap?: boolean; // 内容是否可以换行
  isShow: boolean; // 当前的展示态
  required: boolean; // 是否必须展示
  draggable: boolean; // 是否可以被拖拽
  respond?: boolean; // 是否响应其他元素的拖拽事件
  sort: number; // 排序
}

export const examDefaultColumns: HeaderColumn[] = [
  {
    label: "面试名称",
    required: true,
    prop: "name",
    width: "264px",
    fixed: "left",
    isShow: true,
    draggable: false,
    respond: false,
    canWrap: true,
    sort: 1
  },
  {
    label: "对内名称",
    required: false,
    prop: "innerName",
    width: "264px",
    fixed: "left",
    isShow: false,
    draggable: true,
    respond: false,
    canWrap: true,
    sort: 2
  },
  {
    label: "岗位",
    prop: "positionName",
    required: false,
    isShow: true,
    draggable: true,
    canWrap: true,
    sort: 2
  },
  {
    label: "当前状态",
    prop: "status", // 实际展示
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "90px",
    sort: 3,
    canWrap: true,
    showType: HeaderShowType.Status
  },
  {
    label: "候选人",
    prop: "positionName",
    required: false,
    isShow: true,
    draggable: true,
    sort: 4,
    showType: HeaderShowType.Candidate
  },
  {
    label: "面试进展",
    prop: "positionName",
    required: false,
    isShow: true,
    draggable: true,
    canWrap: true,
    minWidth: "240px",
    sort: 5,
    showType: HeaderShowType.Progress
  },
  {
    label: "面试方式",
    prop: "positionName",
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "90px",
    sort: 6,
    showType: HeaderShowType.ExamType,
    canWrap: true
  },
  {
    label: "题目数",
    prop: "questionNumber",
    required: false,
    isShow: false,
    draggable: true,
    sort: 7
  },
  {
    label: "预计时长",
    prop: "useTimeSecond",
    required: false,
    isShow: false,
    draggable: true,
    minWidth: "90px",
    sort: 8,
    showType: HeaderShowType.UseTimeSecond,
    canWrap: true
  },
  {
    label: "创建时间",
    prop: "createdTime",
    required: false,
    isShow: true,
    draggable: true,
    canWrap: true,
    minWidth: "100px",
    sort: 9,
    showType: HeaderShowType.Time
  },
  {
    label: "更新时间",
    prop: "lastUpdateTime",
    required: false,
    isShow: false,
    draggable: true,
    canWrap: true,
    minWidth: "100px",
    sort: 10,
    showType: HeaderShowType.Time
  }
];

export const candidateDefaultColumns: HeaderColumn[] = [
  {
    label: "姓名/手机",
    required: true,
    width: "200px",
    fixed: "left",
    isShow: true,
    draggable: false,
    respond: false,
    showType: HeaderShowType.Candidate,
    sort: 1
  },
  {
    label: "岗位",
    prop: "positionName",
    required: false,
    minWidth: "132px",
    isShow: true,
    draggable: true,
    sort: 2
  },
  {
    label: "面试名称",
    prop: "examName",
    required: false,
    minWidth: "230px",
    isShow: true,
    draggable: true,
    sort: 3
  },
  {
    label: "面试开始时间",
    prop: "beginTime",
    required: false,
    isShow: true,
    draggable: true,
    canWrap: true,
    minWidth: "152px",
    sort: 4,
    showType: HeaderShowType.Time
  },
  {
    label: "面试完成时间",
    prop: "submitTime",
    required: false,
    isShow: true,
    draggable: true,
    canWrap: true,
    minWidth: "152px",
    sort: 5,
    showType: HeaderShowType.Time
  },
  {
    label: "面试状态",
    prop: "submitStatus",
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "133px",
    sort: 6
  },
  {
    label: "AI评分",
    prop: "scoreAi",
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "112px",
    sort: 7
  },
  {
    label: "胜任力评估结果",
    prop: "aiRecommendStatus",
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "200px",
    sort: 8
  },
  {
    label: "标签",
    prop: "tags",
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "350px",
    sort: 9
  },
  {
    label: "备注",
    prop: "remark",
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "200px",
    sort: 10
  },
  {
    label: "AI面试评估结果",
    prop: "auditStatus",
    required: false,
    isShow: false,
    draggable: true,
    minWidth: "200px",
    sort: 11
  },
  // {
  //   label: "HR评分",
  //   prop: "auditScore",
  //   required: false,
  //   isShow: false,
  //   draggable: true,
  //   minWidth: "200px",
  //   sort: 12
  // },
  {
    label: "通知状态",
    prop: "messageStatus",
    required: false,
    isShow: false,
    draggable: true,
    minWidth: "200px",
    sort: 13
  },
  {
    label: "创建时间",
    prop: "createdTime",
    required: false,
    isShow: false,
    draggable: true,
    canWrap: true,
    minWidth: "200px",
    sort: 14,
    showType: HeaderShowType.Time
  },
  {
    label: "面试结束方式",
    prop: "submitType",
    required: false,
    isShow: false,
    draggable: true,
    minWidth: "200px",
    sort: 15
  },
  {
    label: "编号",
    prop: "connectCode",
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "200px",
    sort: 16
  },
  {
    label: "面试批次",
    prop: "version",
    required: false,
    isShow: true,
    draggable: true,
    minWidth: "150px",
    sort: 17
  }
];
